import invariant from 'invariant';
import { createSelector } from 'reselect';
import { IN_NETWORK_INSURANCE_KEY } from './constants';

const inNetworkInsuranceSelector = createSelector(
    state => {
        if (process.env.NODE_ENV !== 'production') {
            invariant(
                state.hasOwnProperty(IN_NETWORK_INSURANCE_KEY),
                `Expected in network insurances to be available as \`state.${IN_NETWORK_INSURANCE_KEY}\`. `
                + 'Ensure you have added the `inNetworkInsuranceReducer` to your store\'s '
                + 'reducers via `combineReducers`.'
            );
        }

        return state[IN_NETWORK_INSURANCE_KEY];
    },
    inNetworkInsurance => inNetworkInsurance
);

export default inNetworkInsuranceSelector;
